import styled from 'styled-components';
import { px, fontFamilySize } from '../../../contrib/ui';

export const TeamCardActionsStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /* flex-grow: 1; */

  h1.title {
    display: inline-block;
    ${fontFamilySize('Heavy', 18)}
    margin-bottom: 0;
    margin: 0;
    position: relative;
    text-align: left;

    &.edit-mode {
      width: ${px(140)};
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .button {
    width: ${px(80)};
    height: var(--smallButtonHeight);
    margin-left: ${px(5)};

    span {
      ${fontFamilySize('Heavy', 16)}
    }
  }
`;
